import { render, staticRenderFns } from "./booking-pending-approvals-list-non-consecutive-dates-shape.vue?vue&type=template&id=6c1005a2&"
import script from "./booking-pending-approvals-list-non-consecutive-dates-shape.vue?vue&type=script&lang=js&"
export * from "./booking-pending-approvals-list-non-consecutive-dates-shape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports